import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// import { connect } from 'react-redux';
import s from './AccountPaused.css';
import ServerErrorImage from '../images/serverError.svg';
import PrimaryHeader from '../../../components/PrimaryHeader';

class AccountPaused extends Component {
  render() {
    return (
      <div>
        <PrimaryHeader />
        <div className={s.backgroundImg}>
          <div className={s.contentDiv}>
            <div className={s.titleOfError}>Account Paused</div>
            <div className={s.messageOfError}>
              This account has been temporarily paused. Please contact your
              organizational provider for more information.
            </div>
            <img className={s.contentErrorImage} src={ServerErrorImage} />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(AccountPaused);
